import { MenuButton } from "./menu-button.model";
import { PermissionType } from "./permission/permission-type-enum";

export const NavigationItems: MenuButton[] = [
    {
        label: 'menu.home',
        link: 'home',
        icon: 'home',
    },
    {
        label: 'menu.fas',
        link: 'fas',
        icon: 'table_view',
        permissions: [PermissionType.AccessFas],
    },
    {
        label: 'menu.fasSchedule',
        link: 'fas-schedule',
        icon: 'view_timeline',
        permissions: [PermissionType.AccessFas],
    },
    {
        label: 'menu.grns',
        link: 'grns',
        icon: 'qr_code_scanner',
        permissions: [PermissionType.AccessGrns],
    },
    {
        label: 'menu.materialRequestsItemTitle',
        link: 'material-requests-item',
        icon: 'queue',
        permissions: [PermissionType.AccessMaterialRequests],
    },
    {
        label: 'menu.manualPullList',
        link: 'manual-pull-list',
        icon: 'list_alt',
        permissions: [PermissionType.AccessManualPullList],
    },
     {
        label: 'menu.printLabel',
        link: 'print-label',
        icon: 'print',
        permissions: [PermissionType.AccessPrintLabel],
    },
    {
        label: 'menu.admin',
        link: 'admin',
        icon: 'admin_panel_settings',
        permissions: [PermissionType.AccessRoles, PermissionType.AccessUsers, PermissionType.AccessAuditLogs],
        bottom: true,
    },
];